import { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from './logotrans1.png';
import facebook from './Socials/facebook.png';
import instagram from './Socials/instagram.png';
import './styles.css';

type NavProps = {
  home: boolean;
  about: boolean;
  contact: boolean;
  gallery: boolean;
};

const galleryLinks = [
  { label: 'Weddings', to: '/gallery/Weddings' },
  { label: 'Lobola', to: '/gallery/Lobola' },
  { label: 'Birthdays', to: '/gallery/Birthdays' },
  { label: 'Corporate Events', to: '/gallery/Corporate' },
  { label: 'Florals', to: '/gallery/Florals' },
];

export const MainHeader = (props: NavProps) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [galleryOpen, setGalleryOpen] = useState(false);

  const closeMobile = () => {
    setMobileOpen(false);
    setGalleryOpen(false);
  };

  const activeClass = (active: boolean) => `nav-link${active ? ' nav-link--active' : ''}`;

  return (
    <header id="header-container" className="site-header">
      <div className="header-inner">
        <Link to="/" className="brand-link" onClick={closeMobile} aria-label="Rue's Events home">
          <img src={logo} className="Company-logo" alt="Rue's Events Designs" />
        </Link>

        <nav className="desktop-nav" aria-label="Main navigation">
          <Link to="/" className={activeClass(props.home)}>Home</Link>
          <Link to="/about" className={activeClass(props.about)}>About</Link>

          <div
            className="gallery-nav-wrap"
            onMouseEnter={() => setGalleryOpen(true)}
            onMouseLeave={() => setGalleryOpen(false)}
          >
            <Link to="/gallery" className={activeClass(props.gallery)}>
              Gallery <span className="nav-chevron" aria-hidden="true">⌄</span>
            </Link>
            <div className={`gallery-dropdown${galleryOpen ? ' gallery-dropdown--open' : ''}`}>
              {galleryLinks.map((item) => (
                <Link key={item.to} to={item.to}>{item.label}</Link>
              ))}
            </div>
          </div>

          <Link to="/contact" className={activeClass(props.contact)}>Contact</Link>
        </nav>

        <div className="header-actions">
          <div className="header-socials" aria-label="Social links">
            <a href="https://www.facebook.com/Rueseventsdesigns1" target="_blank" rel="noreferrer" aria-label="Rue's Events on Facebook">
              <img src={facebook} className="Facebook-Link" alt="" />
            </a>
            <a href="https://www.instagram.com/rueseventsdesigns/" target="_blank" rel="noreferrer" aria-label="Rue's Events on Instagram">
              <img src={instagram} className="Instagram-Link" alt="" />
            </a>
          </div>
          <Link to="/contact" className="header-cta">Plan Your Event</Link>
        </div>

        <button
          className={`mobile-menu-button${mobileOpen ? ' mobile-menu-button--open' : ''}`}
          type="button"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-expanded={mobileOpen}
          aria-label="Toggle navigation"
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <div className={`mobile-nav${mobileOpen ? ' mobile-nav--open' : ''}`}>
        <Link to="/" className={activeClass(props.home)} onClick={closeMobile}>Home</Link>
        <Link to="/about" className={activeClass(props.about)} onClick={closeMobile}>About</Link>
        <button
          type="button"
          className={`mobile-gallery-toggle${props.gallery ? ' nav-link--active' : ''}`}
          onClick={() => setGalleryOpen(!galleryOpen)}
        >
          Gallery <span>{galleryOpen ? '−' : '+'}</span>
        </button>
        <div className={`mobile-gallery-links${galleryOpen ? ' mobile-gallery-links--open' : ''}`}>
          <Link to="/gallery" onClick={closeMobile}>All Gallery</Link>
          {galleryLinks.map((item) => (
            <Link key={item.to} to={item.to} onClick={closeMobile}>{item.label}</Link>
          ))}
        </div>
        <Link to="/contact" className={activeClass(props.contact)} onClick={closeMobile}>Contact</Link>
        <Link to="/contact" className="mobile-nav-cta" onClick={closeMobile}>Plan Your Event</Link>

        <div className="mobile-socials">
          <a href="https://www.facebook.com/Rueseventsdesigns1" target="_blank" rel="noreferrer" aria-label="Facebook">
            <img src={facebook} alt="" />
          </a>
          <a href="https://www.instagram.com/rueseventsdesigns/" target="_blank" rel="noreferrer" aria-label="Instagram">
            <img src={instagram} alt="" />
          </a>
        </div>
      </div>
    </header>
  );
};
